const greens = {
    1: { main: '#58D466', font: '#000000' },
  };
  
  export default greens;
  